<template>
  <div>
    <v-data-table
      :items-per-page="itemsPerPage"
      :no-data-text="$t('table.noResults')"
      :loading="isLoading"
      :headers="refusedHeaders"
      :items="adminInvoices"
      hide-default-footer
      disable-sort
      show-expand
    >
      <template v-slot:item.created_at="{ item }">
        {{ date(item.created_at) }}
      </template>
      <template v-slot:item.sender="{ item }">
        {{ sender(item) }}
      </template>
      <template v-slot:item.receiver="{ item }">
        {{ receiver(item) }}
      </template>
      <template v-slot:item.total="{ item }">
        {{ formatMoney(item.total) }}
      </template>
      <template v-slot:item.invoice_file_analysis="{ item }">
        <InvoiceAutomaticValidationIcons :invoice="item" />
      </template>
      <template v-slot:item.transfer="{ item }">
        <v-chip v-if="rawTransferStatus(item.transfer)" :color="handleColors(rawTransferStatus(item.transfer))" small>
          {{ transferStatus(item.transfer) }}
        </v-chip>
        <span v-else class="body-2">---</span>
      </template>
      <template v-slot:item.actions="{ item }">
        <AdminInvoiceTableMenu @retryTransfer="retryTransfer" :invoice="item" />
      </template>
      <template v-slot:[`expanded-item`]="{ headers, item }">
        <td :colspan="headers.length" class="content pl-13 pb-10">
          <v-card class="rounded-b-lg" outlined>
            <PaymentList :payments="item.payment_list" />
          </v-card>
        </td>
      </template>
    </v-data-table>

    <v-divider />

    <h-pagination :fetch="fetchAdminInvoices" :requireOrderByFilter="false" :noBorders="true" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { catalogDate, catalogMonetary } from '@/util/catalog'
import { invoiceHeaders, refusedHeaders } from '../adminInvoiceHeaders'
import { handleColors } from '@/util/colors'

import PaymentList from './fragments/PaymentList'
import AdminInvoiceTableMenu from './fragments/AdminInvoiceTableMenu'
import InvoiceAutomaticValidationIcons from './fragments/InvoiceAutomaticValidationIcons'

export default {
  name: 'AdminRefusedInvoices',

  components: {
    PaymentList,
    AdminInvoiceTableMenu,
    InvoiceAutomaticValidationIcons,
  },

  computed: {
    ...mapGetters(['adminInvoices', 'itemsPerPage', 'isLoading']),
  },

  methods: {
    ...mapActions(['fetchAdminInvoices']),

    date(date) {
      return date ? catalogDate(date) : '---'
    },

    rawTransferStatus(transfer) {
      if (!transfer) return null
      return transfer?.status
    },

    transferStatus(transfer) {
      if (!transfer) return this.$t(`hausefulInvoices.waitingTransfer`)
      return this.$t(`transfer.transferStatus.${transfer.status}`)
    },

    sender(item) {
      return item.sender ? this.$t(`hausefulInvoices.${item.sender}`) : '---'
    },

    receiver(item) {
      return item.receiver ? this.$t(`hausefulInvoices.${item.receiver}`) : '---'
    },

    retryTransfer(invoice) {
      this.$emit('retryTransfer', invoice)
    },
  },

  data() {
    return {
      handleColors,
      invoiceHeaders,
      refusedHeaders,
      formatMoney: catalogMonetary,
    }
  },
}
</script>
